import { DEFAULT_GEOAREA_ID } from 'services/geo-management/geoareas'
import { isDefined } from 'services/utils'
import { WithId } from 'types/common'
import { APICfg } from '../../api'
import { parseDoc } from '../catalog/utils'
import { uploadOrKeepFile } from '../common'
import { APIDocument, FormSingleDocument } from '../entities'

export type KampaayerRole = 'admin' | 'sales' | 'ops' | 'marketing'

type APIKampaayer = WithId & {
  kContracts: APIDocument[]
  firstName: string
  lastName: string
  phone: string
  email: string
  domicileAddress: string
  residenceAddress: string
  birthDate: string
  birthPlace: string
  personalNumber: string
  managedGeoareas?: WithId[]
  role: KampaayerRole
}

export type Kampaayer = Omit<APIKampaayer, 'kContracts' | 'managedGeoareas'> & {
  kContracts: FormSingleDocument
  // This will become an array when we support multiple geoareas for a kampaayer
  managedGeoareas: number
}

type KampaayerToAPI = Omit<Kampaayer, 'kContracts' | 'managedGeoareas'> & {
  kContracts: string[]
  managedGeoareas: number[]
}

const apiCfg: APICfg = {
  endpoint: 'userkampaayer',
  parse: ({ kContracts, ...res }: APIKampaayer): Kampaayer => {
    return {
      ...res,
      kContracts: kContracts.map(parseDoc).filter(isDefined),
      // TODO unmock: remove this check once all kampaayers have geoareas
      managedGeoareas: res.managedGeoareas
        ? res.managedGeoareas[0]?.id
        : DEFAULT_GEOAREA_ID,
    }
  },
  write: async (req: Kampaayer): Promise<KampaayerToAPI> => {
    const kContracts = await uploadOrKeepFile(req.kContracts)
    const managedGeoareas = [req.managedGeoareas]

    return {
      ...req,
      kContracts,
      managedGeoareas,
    }
  },
}

export default apiCfg
